import { GET_CLOCK_IN_OUT_LIST, FETCH_ATTENDANCE_TIMELINE } from "../../modules/constants";

export function getClockInOutList(payload) {
  return {
    type: GET_CLOCK_IN_OUT_LIST,
    payload,
  };
}

export function fetchAttendanceTimeline(payload) {
  return {
    type: FETCH_ATTENDANCE_TIMELINE,
    payload,
  };
}